module.exports = __webpack_public_path__ + "static/media/37.499a9cde.jpg";